import { render } from "./ListsSpams.vue?vue&type=template&id=f6026c0e"
import script from "./ListsSpams.vue?vue&type=script&lang=ts"
export * from "./ListsSpams.vue?vue&type=script&lang=ts"
script.render = render

export default script